import request from '@/utils/request'


// 查询设备类型信息列表
export function listDeviceCategorize (query) {
  return request({
    url: '/saifuneng/saifuneng-device-categorize/list',
    method: 'get',
    params: query
  })
}

// 查询设备类型信息分页
export function pageDeviceCategorize (query) {
  return request({
    url: '/saifuneng/saifuneng-device-categorize/page',
    method: 'get',
    params: query
  })
}

// 查询设备类型信息详细
export function getDeviceCategorize (data) {
  return request({
    url: '/saifuneng/saifuneng-device-categorize/detail',
    method: 'get',
    params: data
  })
}

// 新增设备类型信息
export function addDeviceCategorize (data) {
  return request({
    url: '/saifuneng/saifuneng-device-categorize/add',
    method: 'post',
    data: data
  })
}

// 修改设备类型信息
export function updateDeviceCategorize (data) {
  return request({
    url: '/saifuneng/saifuneng-device-categorize/edit',
    method: 'post',
    data: data
  })
}

// 删除设备类型信息
export function delDeviceCategorize (data) {
  return request({
    url: '/saifuneng/saifuneng-device-categorize/delete',
    method: 'post',
    data: data
  })
}
